var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('plus-header',{class:_vm.flag ? '' : 'header-hide',attrs:{"new-msg-notice":_vm.notice,"message-interval":60,"get-user-info":_vm.user}})}
var staticRenderFns = []

export { render, staticRenderFns }